import { PropsWithChildren } from "react";

import { useInitConvia } from "@tudigo-monorepo/web-tudigo-tracking";

export function ConviaProvider(props: PropsWithChildren) {
  useInitConvia();

  return props.children;
}
